import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
  TableEditButtons,
  FormCol3,
  FieldSelectYesNo,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import {
  FieldSelectCollector,
  FieldSelectMaterialGroup,
  FormFieldMultiMaterialDlg,
} from 'shared-pages';
import { useRootStore } from 'store';
import { FieldSelectDocOptions } from 'shared-pages/components/select-dlg/fs-adr';
import { DocFilter } from 'shared-pages/common/constants';
import { buildWhereFromDocFilter } from 'shared-pages/common/filters-helpfunc';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ to: likeObj }, { subject: likeObj }, { originatedFrom: likeObj }],
      };
    }

    if (values.composedFromDate || values.composedTillDate)
      where = {
        ...where,
        ...buildWhereForDates(values.composedFromDate, values.composedTillDate, 'composedDate'),
      };
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  //
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    composedFromDate: initialValues?.composedFromDate ?? null,
    composedTillDate: initialValues?.composedTillDate ?? null,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση ( προέλευση, παραλήπτης, θέμα )')}
          type="search"
          disable={disable}
        />
        <FieldDateRanger
          as={FormCol}
          label={t('Ημερομηνία Σύνταξης από')}
          label2={t('έως')}
          name="composedFromDate"
          name2="composedTillDate"
        />
      </Row>
    </FormFilterCard>
  );
};
